import { postWithAuth, getWithAuth } from '../../../Basic/HttpService';

export const getJobDetailsById = async (Id) => {
    let res = await getWithAuth(`VehicleJob/${Id}`);
    return res;
};
export const getAllJobDropDowns = async (Id = '', VehicleID = '') => {
    let res = await getWithAuth(`VehicleJob/Dropdowns?VehicleJobID=${Id}&VehicleID=${VehicleID}`);
    return res;
};
// export const getAllJobDropDowns = async (Id) => {
//     let res = await getWithAuth(`VehicleJob/Dropdowns?VehicleID=${Id}`);
//     return res;
// };
export const postJobDetails = async (data) => {
    let res = await postWithAuth('VehicleJob', data);
    return res;
};
export const getJobHistory = async (id) => {
    let res = await getWithAuth(`VehicleJob/VehicleJobHistory/${id}`);
    return res;
};
export const getUpcomingEvents = async (id) => {
    let res = await getWithAuth(`VehicleJob/VehicleUncompletedSchedules/${id}`);
    return res;
};

export const mergeJobToMaster = async (data) => {
    let res = await postWithAuth(`schedules/SchedulesAddToJob`, data);
    return res;
};
export const setCompletionDate = async (data) => {
    let res = await postWithAuth(`VehicleJob/VehicleJobsCompleteJob`, data);
    return res;
};
export const setBookingDate = async (data) => {
    let res = await postWithAuth(`VehicleJob/ChangeBookingDate`, data);
    return res;
};

export const getJobRequiredDocuments = async (id) => {
    let res = await getWithAuth(`VehicleJob/GetJobRequiredDocuments/${id}`);
    return res;
};
export const getJobRequireScheduledDocuments = async (id) => {
    let res = await getWithAuth(`Schedules/GetScheduleRequiredDocuments/${id}`);
    return res;
};

export const setVehicleArrive = async (data) => {
    let res = await postWithAuth(`VehicleJob/VehicleArrived`, data);
    return res;
};

export const postJobMileage = async (data) => {
    let res = await postWithAuth(`VehicleJob/VehicleJobMileage`, data);
    return res;
};

export const getJobEnggById = async (Id) => {
    let res = await getWithAuth(`VehicleJob/GetEngineersByServiceAreea?ServiceAgentID=${Id}`);
    return res;
};
export const getVehicleContractEnggById = async (Id, vehicleID, fromPage) => {
    let res = await getWithAuth(
        `VehicleContract/GetEngineersByServiceArea_VehicleContract?ServiceAgentID=${Id}&VehicleID=${vehicleID || ''}${fromPage ? `&fromPage=${fromPage}` : ''}`
    );
    return res;
};
export const getContractEnggById = async (Id, ContractID = '') => {
    let res = await getWithAuth(`Contracts/GetEngineersByServiceArea_Contract?ServiceAgentID=${Id}&ContractID=${ContractID}`);
    return res;
};
export const getSechduleEnggBySAId = async (Id, scheduleId = '') => {
    let res = await getWithAuth(`Schedules/GetEngineersByServiceArea_Schedules?ServiceAgentID=${Id}&ScheduleID=${scheduleId}`);
    return res;
};

export const getVehicleJobGetEngineersByServiceArea = async (ServiceAgentID, JobID) => {
    let res = await getWithAuth(`VehicleJob/VehicleJobGetEngineersByServiceArea?ServiceAgentID=${ServiceAgentID}&JobID=${JobID}`);
    return res;
};

export const getCheckMotHistoryNew = async (regNo) => {
    let res = await getWithAuth(`Vehicles/CheckMotHistoryNew?regNo=${regNo}`);
    return res;
};

export const getVehicleToCopyJob = async (customerId, currentVehicleId) => {
    let res = await getWithAuth(`VehicleJob/GetVehicleToCopyJob?CustomerID=${customerId}&CurrentVehicleID=${currentVehicleId}`);
    return res;
};

export const copyVehicleJobs = async (data) => {
    let res = await postWithAuth(`VehicleJob/CopyVehicleJobs`, data);
    return res;
};

